

<template>
  <div>
    <CRow>
      <CCol sm="12">
          <CCard class='tablewrapper'>
            <CCardHeader>
              <CIcon name="cil-grid"/> 学校管理
              <div class="card-header-actions">
                <a
                  class="card-header-action"
                  rel="noreferrer noopener"
                  target="_blank"
                >
                </a>
              </div>
            </CCardHeader>
            <CCardBody>
              <CRow class="my-2">
                <CCol sm="6" class="form-inline">
                  <label class="mr-2">Filter:</label>
                  <input type="text" placeholder="type string..." class="form-control" v-model="searchKeyWord">
                </CCol>
                <CCol v-if="!isNotPermitted" sm="6" class="text-right">
                  <CButton color="info" @click='showRecordModal({},0, "Create")'>新規作成</CButton>
                </CCol>
              </CRow>
              <CDataTable
                :hover="true"
                :striped="true"
                :items="items"
                :loading="isLoading"
                :fields="fields"
                :itemsPerPage="20"
                pagination
                class='table-scroll'
              >
                <template #unprocess="{item}">
                  <td class="py-2 text-center">
                    <p class="mb-1 text-center red"><b>{{ jobs[item.id] }}</b></p>
                    <router-link  class="slide-item" :to="'/schools/' + item.id">
                      <CButton  color="danger" variant="outline" square size="sm">処理する</CButton>
                    </router-link>
                  </td>
                </template>
                <template #school_type="{item}">
                  <td class="py-2">
                    {{ schoolDict[item.school_type]}}
                  </td>
                </template>

                <template #school_course="{item}">
                  <td class="py-2">
                    {{ courseDict[item.school_course] }}
                  </td>
                </template>

                <template #school_division="{item}">
                  <td class="py-2">
                    {{ divisionDict[item.school_division] }}
                  </td>
                </template>

                <template #fix="{item}">
                  <td class="text-center">
                    {{ item.manage_status.fix ?? 0 }}
                  </td>
                </template>

                <template #auto_fix="{item}">
                  <td class="text-center">
                    {{ item.manage_status.auto_fix ?? 0  }}
                  </td>
                </template>

                <template #not_fix="{item}">
                  <td class="text-center">
                    {{ item.manage_status.not_fix ?? 0  }}
                  </td>
                </template>

                <template #is_enable_sso="{item}">
                  <td class="py-2">
                    {{ formatSSOValue(item.is_enable_sso) }}
                  </td>
                </template>

                <template #not_parseable="{item}">
                  <td class="text-center">
                    {{ item.manage_status.not_parseable ?? 0  }}
                  </td>
                </template>

                 <template #show_details="{item, index}">
                  <td class="py-2">
                    <CButton class="mr-2" color="dark" variant="outline" square size="sm" @click="showRecordModal(item, index)">編集</CButton>
                    <CButton class="mr-2" color="danger" variant="outline" square size="sm" @click="showDeleteModal(item, index)">削除</CButton>
                  </td>
                </template>
                <template #under-table>

                  <CCol sm="12" class="text-center">
                    <paginate
                      v-model="page"
                      :page-count="meta.total_pages"
                      :prev-text="'前へ'"
                      :next-text="'次へ'"
                      :click-handler="paging"
                      :container-class="'pagination'">
                    </paginate>
                  </CCol>
                </template>

              </CDataTable>

            </CCardBody>
          </CCard>
      </CCol>
    </CRow>
    <CModal
      :title="modalModeTitle()"
      :color="modalModeCss()"
      :show.sync="recordModal"
    >
       <CRow class="form-box">
         <CCol sm="12">
           <label class="record-label pt-3">学校名</label>
           <CInput placeholder="会場番号" v-model="record.name" :class="{ 'hasError': $v.record.name.$error }"/>

           <small v-if="$v.record.name.$error" class="errorLabel">学校名を入れてください</small>
         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">都道府県</label>
           <CSelect
             placeholder="都道府県を選択してください"
             :options="prefectures"
             :value.sync="record.prefecture_id"
           />
         </CCol>

         <CCol sm="12">
           <label class="record-label pt-3">郵便番号</label>
           <CInput placeholder="000-0000" v-model="record.zip" :class="{ 'hasError': $v.record.zip.$error }" />
           <small v-if="$v.record.name.$error" class="errorLabel">郵便番号を入れてください</small>
         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">住所1</label>
           <CInput placeholder="郵便番号" v-model="record.address1" :class="{ 'hasError': $v.record.address1.$error }"/>
           <small v-if="$v.record.address1.$error" class="errorLabel">住所1を入れてください</small>
         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">住所2</label>
           <CInput placeholder="" v-model="record.address2" :class="{ 'hasError': $v.record.address2.$error }"/>
           <small v-if="$v.record.address2.$error" class="errorLabel">住所2を入れてください</small>
         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">住所3</label>
           <CInput placeholder="" v-model="record.address3" :class="{ 'hasError': $v.record.address3.$error }"/>
           <small v-if="$v.record.address3.$error" class="errorLabel">住所3を入れてください</small>
         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">url</label>
           <CInput placeholder="" v-model="record.url" :class="{ 'hasError': $v.record.url.$error }"/>
           <small v-if="$v.record.url.$error" class="errorLabel">urlを入れてください</small>
         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">email</label>
           <CInput placeholder="" v-model="record.email" :class="{ 'hasError': $v.record.email.$error }"/>
           <small v-if="$v.record.email.$error" class="errorLabel">emailを入れてください</small>
         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">学校種別</label>
           <CSelect
             placeholder="学校種別を選択してください"
             :class="{ 'hasError': $v.record.school_type.$error }"
             :options="schoolTypes"
             :value.sync="record.school_type"
           />
           <small v-if="$v.record.school_type.$error" class="errorLabel">学校種別を入れてください</small>
         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">課程種別</label>
           <CSelect
             placeholder="課程種別を選択してください"
             :class="{ 'hasError': $v.record.school_course.$error }"
             :options="courseTypes"
             :value.sync="record.school_course"
           />
           <small v-if="$v.record.school_course.$error" class="errorLabel">課程種別を入れてください</small>
         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">学科区分</label>
           <CSelect
             placeholder="学科区分を選択してください"
             :class="{ 'hasError': $v.record.school_division.$error }"
             :options="divisionTypes"
             :value.sync="record.school_division"
           />
           <small v-if="$v.record.school_division.$error" class="errorLabel">学科区分を入れてください</small>
         </CCol>

         <CCol sm="12">
           <label class="record-label pt-3">就職者数</label>
           <CInput placeholder="" v-model="record.work_number" :class="{ 'hasError': $v.record.work_number.$error }"/>
           <small v-if="$v.record.work_number.$error" class="errorLabel">就職者数を入れてください</small>
         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">就職者数(うち男性)</label>
           <CInput placeholder="" v-model="record.work_male_number" :class="{ 'hasError': $v.record.work_male_number.$error }"/>
           <small v-if="$v.record.work_male_number.$error" class="errorLabel">就職者数(うち男性)を入れてください</small>
         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">就職者数(うち女性)</label>
           <CInput placeholder="" v-model="record.work_female_number" :class="{ 'hasError': $v.record.work_female_number.$error }"/>
           <small v-if="$v.record.work_female_number.$error" class="errorLabel">就職者数(うち女性)を入れてください</small>
         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">就職率</label>
           <CInput placeholder="" v-model="record.work_rate" :class="{ 'hasError': $v.record.work_rate.$error }"/>
           <small v-if="$v.record.work_rate.$error" class="errorLabel">就職率を入れてください</small>
         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">契約状態</label><br>
           <CSwitch
            v-bind="{ variant: '3d', shape: 'pill'  }"
            color='primary'
            :checked.sync="record.is_contract"
            :class="{ 'hasError': $v.record.is_contract.$error }"
          />
           <small v-if="$v.record.is_contract.$error" class="errorLabel">契約状態を入れてください</small>
         </CCol>
       </CRow>

       <template #footer>
         <CButton size="sm" @click="hideRecordModal()">キャンセル</CButton>
         <CButton size="sm" color="info" @click="updateItem(mode, itemIndex)">登録</CButton>
       </template>
    </CModal>

    <CModal
      title="削除しますか？"
      color="danger"
      :show.sync="deleteModal"
    >
      <div class="text-center">
        <p>この学校を削除しますか？？</p>
        <p>削除してしまうと復元することはできません</p>
      </div>
      <template #footer>
        <CButton size="sm" @click="hideDeleteModal()">キャンセル</CButton>
        <CButton size="sm" color="danger" @click="deleteItem()">削除</CButton>
      </template>
    </CModal>




  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { required } from "vuelidate/lib/validators";
import Paginate from 'vuejs-paginate'
import { mapGetters } from 'vuex';

export default {
  name: 'Home',
  components: {Paginate},
  data() {
    return {
      isLoading: false,
      mode: 'Create',
      record: {},
      recordModal: false,
      deleteModal: false,
      itemIndex: 0,
      items: [],
      filter_cs: [],
      filter_vs: [],
      industryTypes: [],
      page: 1,
      word: "",
      sort_column: "id",
      sort_asc: "desc",
      select_gender: '',
      select_status: '',
      meta: {},
      industries: {},
      jobs: {},
      schoolDict:{
        'public': '公立',
        'private': '私立',
        'national': '国立'
      },
      schoolTypes: [
         {
            label: "公立",
            value: "public",
         },
         {
            label: "私立",
            value: "private",
         },
         {
            label: "国立",
            value: "national"
         }
      ],
      courseDict:{
        'full': '全日制',
        'part_time': '定時制',
        'communication': '通信制',
        'credit': '単位制'
      },
      courseTypes: [
        {
          value: "full",
          label: "全日制",
        },
        {
          value: "part_time",
          label: "定時制"
        },
        {
          value: "communication ",
          label: "通信制",
        },
        {
          value: "credit",
          label: "単位制",
        }
      ],
      divisionDict:{
        'nomal': '普通科',
        'industry': '工業科',
        'commercial': '商業科',
        'form': '農業科',
        'comprehensive': '総合学科',
      },
      divisionTypes: [
         {
            value: "nomal",
            label: "普通科",
         },
         {
            value: "industry",
            label: "工業科"
         },
         {
            value: "commercial",
            label: "商業科",
         },
         {
            value: "form",
            label: "農業科",
         },
         {
            value: "comprehensive",
            label: "総合学科"
         },
      ],
      fields: [
        { key: 'id', label: 'ID' },
        { key: 'name', label: "学校名"},
        { key: 'zip', label: "郵便番号"},
        { key: 'address1', label: "住所1"},
        { key: 'address2', label: "住所2"},
        { key: 'address3', label: "住所3"},
        { key: 'url', label: "url"},
        { key: 'email', label: "email"},
        { key: 'school_type', label: "学校種別"},
        { key: 'school_course', label: "課程種別"},
        { key: 'school_division', label: "学科区分"},
        { key: 'work_number', label: "就職者数"},
        { key: 'work_male_number', label: "就職者数(男性)"},
        { key: 'work_female_number', label: "就職者数(女性)"},
        { key: 'work_rate', label: "就職率"},
        { key: 'fix', label: "修正済"},
        { key: 'auto_fix', label: "反映済"},
        { key: 'not_fix', label: "未修正"},
        { key: 'not_parseable', label: "解析不可"},
        { key: 'is_contract', label: "契約状態"},
        { key: 'is_enable_sso', label: "SSO"},
        { key: 'unprocess', label: "未処理求人数"},
        { key: 'show_details', label: '',  _style: 'width:15%', sorter: false, filter: false},
      ],
      memberDic: {"associate_member": "仮登録", "no_deposite_member": "本登録(未入金)", "member": "本登録"},
      searchKeyWord: "",
      isSearching: false,
      prefectures: []
    }
  },
  validations: {
    record: {
      name: {required},
      zip: {required},
      address1: {required},
      address2: {required},
      address3: {required},
      url: {required},
      email: {required},
      school_type: {required},
      school_course: {required},
      school_division: {required},
      work_number: {required},
      work_male_number: {required},
      work_female_number: {required},
      work_rate: {required},
      is_contract: {required},
    }
  },
  methods: {
    formatIndustry: function(d) {
      //var s = ""
      //d.split(",").forEach(i => {
      //  s += this.industries[i] + ","
      //})
      return d
    },
    formatSSOValue: function(d) {
      switch(d) {
        case true:
          return "ON"
        case false:
          return "OFF"
        default:
          return "---"
      }
    },
    formatDate: function(d) {
        return moment(d).format("YYYY/MM/DD")
    },
    formatBirthday: function(d) {
        return moment(d).format("YYYY/MM/DD")
    },
    modalModeCss: function() {
      return (this.mode == "Create")? "info" : "dark"
    },
    modalModeTitle: function() {
      return (this.mode == "Create")? "新規学校追加" : "編集"
    },
    showRecordModal: function(i, index, mode="Edit") {
      this.recordModal = true
      this.record = i

      this.mode = mode
      this.itemIndex = index
    },
    showDeleteModal: function(i, index) {
      this.deleteModal = true
      this.record = i
      this.itemIndex = index
    },
    hideRecordModal: function() {
      this.recordModal = false
    },
    hideDeleteModal: function() {
      this.deleteModal = false
    },
    deleteItem: function() {
      axios
        .delete(process.env.VUE_APP_API_ENDPOINT + "/api/mng/schools/" + this.record.id, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(() => {
          this.deleteModal = false
          this.items.splice(this.itemIndex, 1)
        }).catch(error => {
          this.deleteModal = false
          this.errorNotify(error.response)
        })
    },
    updateItem: function(mode="Create", index=0) {
      // this.$v.record.$touch();
      // if(this.$v.record.$error) return

      if(mode == "Create") {
        console.log(this.record)
        axios
          .post(process.env.VUE_APP_API_ENDPOINT + "/api/mng/schools", {"school": this.record}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(response => {
            this.recordModal = false
            this.items.unshift(response.data)
          }).catch(error => {
            this.errorNotify(error.response)
          })
      } else {
        console.log(this.record)
        axios
          .patch(process.env.VUE_APP_API_ENDPOINT + "/api/mng/schools/" + this.record.id, {"school": this.record}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(() => {
            this.recordModal = false
            this.items[index] = this.record
          }).catch(error => {
            this.errorNotify(error.response)
          })
      }
    },
    paging: function(n) {
      // axios
      //   .get(process.env.VUE_APP_API_ENDPOINT + "/api/mng/schools?page=" + n, {headers: {'Authorization': 'Bearer ' + this.idToken}})
      //   .then(response => {
      //       this.items = response.data.schools
      //       this.meta = response.data.meta
      //       this.jobs = response.data.jobs
      //   }).catch(error => {
      //       this.errorNotify(error.response)
      //   })
      if(this.isSearching) {
        axios
          .get(process.env.VUE_APP_API_ENDPOINT + "/api/mng/schools?&key_word=" + encodeURIComponent(this.word) + "&page=" + n + "&column=" + this.sort_column + "&direction=" + this.sort_asc, {headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(response => {
              this.items = response.data.schools
              this.meta = response.data.meta
              this.jobs = response.data.jobs
          }).catch(error => {
              this.errorNotify(error.response)
          })
      } else {
        axios
          .get(process.env.VUE_APP_API_ENDPOINT + "/api/mng/schools?page=" + n, {headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(response => {
              this.items = response.data.schools
              this.meta = response.data.meta
              this.jobs = response.data.jobs
          }).catch(error => {
              this.errorNotify(error.response)
          })
      }
    },
    // comment local filter + unused code
    // search: function(e, c) {
    //   this.word = e
    //   if(c != undefined){
    //     this.filter_update(c.target.name, e)
    //   }
    //   if(e == "-") {
    //     this.word = ""
    //   }
    //   axios
    //     .get(process.env.VUE_APP_API_ENDPOINT + "/api/mng/schools?filter_columns=" + this.filter_cs.join(",") + "&filter_values=" + this.filter_vs.join(",") + "&page=" + this.page + "&column=" + this.sort_column + "&direction=" + this.sort_asc, {headers: {'Authorization': 'Bearer ' + this.idToken}})
    //     .then(response => {
    //       this.items = response.data.schools
    //       this.meta = response.data.meta
    //       this.jobs = response.data.jobs
    //     }).catch(error => {
    //         this.errorNotify(error.response)
    //     })
    // },
    // filter_update: function(k, v) {
    //   if(this.filter_cs.includes(k)) {
    //     var i = this.filter_cs.indexOf(k)
    //     if(v == "-") {
    //       this.filter_cs.splice(i, 1)
    //       this.filter_vs.splice(i, 1)
    //     } else {
    //       this.filter_cs[i] = k
    //       this.filter_vs[i] = v
    //     }
    //   } else {
      //     this.filter_cs.push(k)
    //     this.filter_vs.push(v)
    //   }
    // },
    // updatePageData: function(n, e) {
    //   this.page = n
    //   console.log(e)
    //   axios
    //     .get(process.env.VUE_APP_API_ENDPOINT + "/api/mng/schools?page=" + n + "&word=" + this.word, {headers: {'Authorization': 'Bearer ' + this.idToken}})
    //     .then(response => {
    //       this.items = response.data.schools
    //       this.meta = response.data.meta
    //       this.jobs = response.data.jobs
    //     }).catch(error => {
    //       this.errorNotify(error.response)
    //     })
    // },
    search: function(key_word) {
      if(key_word != "") {
        this.isSearching = true;
        this.page = 1;
        this.word = key_word
        if(key_word == "-") {
          this.word = ""
        }
        axios
          .get(process.env.VUE_APP_API_ENDPOINT + "/api/mng/schools?&key_word=" + encodeURIComponent(this.word) + "&page=" + this.page + "&column=" + this.sort_column + "&direction=" + this.sort_asc, {headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(response => {
            this.items = response.data.schools
            this.meta = response.data.meta
            this.jobs = response.data.jobs
          }).catch(error => {
              this.errorNotify(error.response)
          })
      } else {
        this.isSearching = false;
        this.page = 1;
        axios
          .get(process.env.VUE_APP_API_ENDPOINT + "/api/mng/schools", {headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(response => {
            this.items = response.data.schools
            this.meta = response.data.meta
            this.jobs = response.data.jobs
          }).catch(error => {
            this.errorNotify(error.response)
          })
      }
    },
  },
  watch: {
    searchKeyWord(newValue) {
      this.search(newValue)
    }
  },
  mounted() {
    axios
      .get(process.env.VUE_APP_API_ENDPOINT + "/api/mng/schools", {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
        this.items = response.data.schools
        this.meta = response.data.meta
        this.jobs = response.data.jobs
        response.data.prefectures.forEach((p) => {
          this.prefectures.push({
            value: p.id,
            label: p.name
          })
        })

      }).catch(error => {
        this.errorNotify(error.response)
      })
    if(this.isNotPermitted) {
      this.fields.forEach((field, index) => {
        if(field.key == 'show_details') {
          this.fields.splice(index, 1)
        }
      })
    }
  },
  computed: {
    ...mapGetters({
      idToken:'GetIdToken',
      role: 'GetRole',
    }),
    isNotPermitted() {
      return this.role == 'member'
    }
  },
}
</script>
<style scoped>
.tablewrapper{
  overflow-x: scroll;
}
.table-scroll{
  border-collapse: collapse;
  white-space: nowrap;
}
.red{
  color: red
}
</style>
